import { MODAL_STYLES } from "../../constants/modal-styles";
import { ModalButton } from "./ModalButton";

interface MessageModalProps {
  isOpen: boolean;
  language: "ka" | "en";
  title: string;
  message: string;
  onClose: () => void;
}

export const MessageModal = ({
  isOpen,
  language,
  title,
  message,
  onClose,
}: MessageModalProps) => {
  if (!isOpen) return null;

  const content = {
    ka: {
      close: "დახურვა",
    },
    en: {
      close: "Close",
    },
  };

  const text = content[language] || content.ka;

  return (
    <div className={MODAL_STYLES.overlay} onClick={onClose}>
      <div
        className={MODAL_STYLES.modal}
        onClick={(e) => e.stopPropagation()}
        style={{
          fontFamily: MODAL_STYLES.fontFamily,
        }}
      >
        <div
          className={`${MODAL_STYLES.content} flex flex-col items-center justify-center`}
        >
          <div className={MODAL_STYLES.message}>{message}</div>

          <ModalButton onClick={onClose}>{text.close}</ModalButton>
        </div>
      </div>
    </div>
  );
};
